<template>
  <div class="page landing" :class="{'show-iframe': showIframe}">
    <template v-if="showIframe">
      <iframe
        ref="externalIframe"
        class="external-iframe"
        frameborder="0"
        :src="iframeUrl"
      ></iframe>
    </template>
    <template v-else>
      <section class="content">
        <!-- 表单内容 -->
        <form ref="form" class="form">
          <div ref="mobileRef" class="form-item">
            <nd-input
              name="mobile"
              v-model="form.mobile"
              placeholder="输入手机号"
              type="pure-number"
              maxLength="11"
              @focus="mobileFocus"
            />
          </div>
          <div ref="codeRef" class="form-item">
            <nd-input
              name="smsCode"
              v-model="form.smsCode"
              placeholder="请输入验证码"
              type="pure-number"
              maxLength="6"
              @focus="codeFocus"
            />
            <nd-send-code
              class="send-code"
              :disabled="smsDisabled"
              :sendCode="sendCodeHandler"
            />
          </div>
          <div ref="agreeRef" class="agree">
            <van-checkbox v-model="agreeChecked" checked-color="#FF4633">
              请您阅读并同意
              <span class="highlight" @click.stop="protocolPopup = true">用户服务协议</span>
            </van-checkbox>
          </div>
          <div class="btn-name">
            <div class="btn" @click="goLoan">
              <span>查看我的额度</span>
            </div>
          </div>
        </form>
      </section>
    </template>
    <van-popup
      v-model="protocolPopup"
      class="protocol-popup"
      position="bottom"
    >
      <dl>
        <dt>
          用户服务协议
          <img
            src="https://static.ndmicro.com/tmd/landing/data-distribution/images/btn_close.png"
            srcset="
              https://static.ndmicro.com/tmd/landing/data-distribution/images/btn_close@2x.png 2x,
              https://static.ndmicro.com/tmd/landing/data-distribution/images/btn_close@3x.png 3x
            "
            @click="protocolPopup = false"
          />
        </dt>
        <dd tag="dd" v-for="(item, index) in protocols" :key="index" @click="routerToProtocol(item.path)">
          {{item.name}}
        </dd>
      </dl>
    </van-popup>
  </div>
</template>

<script>
import { judgeClientSystem } from '@/assets/utils'
import { Swipe, SwipeItem, Popup, Checkbox } from 'vant'
import { mapActions, mapState } from 'vuex'
import validate from '../../../components/nd-validate'
import isIntercept from '@/assets/intercept-mixin'
import configMixins from '../configMixins'
import axios from '@/assets/axios'
export default {
  name: 'landingGeneral',

  mixins: [validate, configMixins],

  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    Popup,
    VanCheckbox: Checkbox
  },

  data () {
    return {
      isIos: judgeClientSystem() === 'IOS',
      showBg2: ['H5-nwd', 'H5-nwd1', 'H5-nwd2'].includes(this.$route.query.channel),
      list: [
        { maskMobile: '176****5313', amount: '35000' },
        { maskMobile: '128****2145', amount: '13000' },
        { maskMobile: '177****7623', amount: '25000' },
        { maskMobile: '178****1213', amount: '18000' },
        { maskMobile: '137****4532', amount: '9000' },
        { maskMobile: '169****8907', amount: '11000' },
        { maskMobile: '136****7832', amount: '8000' },
        { maskMobile: '138****3232', amount: '23000' },
        { maskMobile: '138****3476', amount: '11000' },
        { maskMobile: '176****3487', amount: '17000' },
        { maskMobile: '178****2367', amount: '13000' },
        { maskMobile: '189****8904', amount: '13000' },
        { maskMobile: '139****7690', amount: '25000' },
        { maskMobile: '136****1323', amount: '18000' },
        { maskMobile: '179****7643', amount: '9000' },
        { maskMobile: '187****7720', amount: '11000' },
        { maskMobile: '135****8934', amount: '8000' },
        { maskMobile: '155****9087', amount: '23000' },
        { maskMobile: '139****0023', amount: '11000' },
        { maskMobile: '176****1367', amount: '35000' }
      ],
      form: {
        mobile: '',
        smsCode: '',
        smsKey: ''
      },
      captchaVisible: false,
      rules: {
        mobile: [
          {
            require: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            regular: /^1[0-9]{10}$/,
            message: '手机号码格式错误，请重新输入',
            trigger: 'blur'
          }
        ],
        smsCode: [
          {
            require: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            regular: /[0-9]{6}$/,
            message: '验证码错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      channel: '',
      popupTime: 0,
      imageCode: '',
      randomArray: [],
      context: null,
      protocolPopup: false,
      protocols: [{ name: '《天美贷用户注册及服务协议》', path: '/tmd/protocol/login' }, { name: '《天美贷隐私政策》', path: '/tmd/protocol/privacy' }],
      nextNode: 'CREDIT_RESULT',
      loanList: null,
      serialNo: null,
      half: false,
      agreeChecked: false,
      showIframe: false,
      iframeUrl: ''
    }
  },

  watch: {
    'form.smsCode' (val) {
      if (val && val.length === 6) {
        this.$sensors.track('general_event', {
          additinal_status: 'code_complete'
        })
      }
    }
    // showIframe (val) {
    //   if (val) {
    //     this.setVendorViewport()
    //   } else {
    //     this.resetViewport() 
    //   }
    // }
  },
  async created () {
    this.$bus.$emit('ready')
    // 获取落地页渠道
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
    await isIntercept(this.channel)
  },
  beforeDestroy () {
    this.resetViewport()
  },
  computed: {
    smsDisabled () {
      const disabled = !this.validateWithoutTip({ mobile: this.rules.mobile })
      if (!disabled) {
        this.$sensors.track('general_event', {
          additinal_status: 'mobile_complete'
        })
      }
      return disabled
    },

    ...mapState('user', {
      authStatus: (state) => state.userInfo.authStatus || []
    })
  },

  methods: {
    ...mapActions('user', ['sendCodeX', 'loginBySmsX', 'getUserInfoX', 'getIRR24', 'getChannelJumpX', 'distributeUnionLogin']),
    ...mapActions('authentication', ['channelConfigX']),
    randomNumber (num) {
      var random = ''
      for (var i = 0; i < num; i++) {
        random += Math.floor(Math.random() * 10)
      }
      return random
    },

    // 点击获取验证码
    sendCodeHandler () {
      this.$sensors.track('general_event', {
        'submissions': { mobile: this.form.mobile }
      })
      return new Promise((resolve, reject) => {
        this.sendCodeX({
          mobile: this.form.mobile
        }).then(response => {
          if (response.success) {
            this.form.smsKey = response.data.smsKey
            resolve(true)
          } else {
            reject(new Error(response.msg))
          }
        })
      })
    },

    // 校验验证码
    verifyCode () {
      this.$indicator()
      setTimeout(() => {
        this.$indicator.close()
        if (this.imageCode === this.random) {
          this.captchaVisible = false
          this.$emit('captcha-passed')
        } else {
          this.$message('验证码错误')
        }
      }, 500)
    },

    // 立即借款
    async goLoan () {
      const res = this.validateWithoutTip(this.rules, (msg) => {
        if (['请输入手机号', '手机号码格式错误，请重新输入'].includes(msg)) {
          this.$refs['mobileRef'].classList.add('shake')
          setTimeout(() => {
            this.$refs['mobileRef'].classList.remove('shake')
          }, 600)
        }
        if (['请输入验证码', '验证码错误，请重新输入'].includes(msg)) {
          this.$refs['codeRef'].classList.add('shake')
          setTimeout(() => {
            this.$refs['codeRef'].classList.remove('shake')
          }, 600)
        }
        this.$message(msg)
      })
      if (!res) return
      if (!this.agreeChecked) {
        this.$refs['agreeRef'].classList.add('shake')
        setTimeout(() => {
          this.$refs['agreeRef'].classList.remove('shake')
        }, 600)
        return this.$message('请先勾选并同意用户服务协议')
      }
      if (this.$route.query) {
        this.form.extParam = this.$route.query
      }
      this.$sensors.track('general_event', {
        'submissions': { mobile: this.form.mobile, smsCode: this.form.smsCode }
      })
      const response = await this.loginBySmsX(this.form)
      if (response.success) {
        this.$statistics('LOGIN')
        await this.getUserInfoX({ forceUpdate: true, checkToken: true })
        await this.getProcessType()
        await this.getChannelConfig()
      } else {
        if (response.code === '000010') {
          this.$message(response.msg)
        }
      }
    },
    // setVendorViewport () {
    //   this.setViewPort('width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover')
    // },
    // resetViewport () {
    //   this.setViewPort('user-scalable=no,viewport-fit=cover')
    // },
    // setViewPort (viewportContent) {
    //   const metaViewport = document.querySelector('meta[name="viewport"]')
    //   if (metaViewport) {
    //     // 获取 viewport 的内容
    //     const currentViewportContent = metaViewport.getAttribute('content')
    //     if (viewportContent === currentViewportContent) {
    //       return
    //     }
    //     const newViewportContent = viewportContent
    //     metaViewport.setAttribute('content', newViewportContent)
    //   }
    // },
    // 获取渠道配置
    async getChannelConfig () {
      const { success, data } = await this.channelConfigX(
        { channelNo: this.channel }
      )
      if (success &&
        data.landingDiversionType &&
        data.landingDiversionType === 'UNION_DIVERSION') {
          // 联登导流
          await this.dataDistributeProcess()
      } else {
        this.nextStep()
      }
    },
    // 分流流程
    async dataDistributeProcess () {
      const { success, data } = await this.distributeUnionLogin({
        channelNo: this.channel
      })
      if (success) {
        const url = data.jumpUrl
        switch (data.jumpType) {
          case 'IFRAME': // IFRAME加载
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0
            this.iframeUrl = url
            this.showIframe = true
            break
          case 'FREE': // NDS解析
            window.location.href = url
            break
          default:
            this.nextStep()
            break
        }
      } else {
        this.nextStep()
      }
    },
    // 判断用户下一步走什么流程
    async nextStep () {
      const { success, data } = await this.getChannelJumpX()
      if (success && data) {
        return this.handleLandingJump(data.type, 'data-distribution')
      }
    },

    async getProcessType () {
      const res = await axios.post('/order/v1/biz-route', {
        channelNo: this.channel
      })
      if (res.data.success) {
        this.nextNode = res.data.data.currentNode
        this.loanList = res.data.data.loanList
        this.serialNo = res.data.data.serialNo
        this.half = res.data.data.half
      }
    },
    mobileFocus () {
      this.$sensors.track('general_event', {
        additinal_status: 'mobile_focus'
      })
    },
    codeFocus () {
      this.$sensors.track('general_event', {
        additinal_status: 'code_focus'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes shake {
  20% {
    -webkit-transform: rotate(2.5deg);
    transform: rotate(2.5deg)
  }
  40% {
    -webkit-transform: rotate(-2.5deg);
    transform: rotate(-2.5deg)
  }
  60% {
    -webkit-transform: rotate(2.5deg);
    transform: rotate(2.5deg)
  }
  80% {
    -webkit-transform: rotate(-2.5deg);
    transform: rotate(-2.5deg)
  }
  to {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }
}
.landing {
  height: 1796px;
  background-image:url(https://static.ndmicro.com/tmd/landing/data-distribution/images/img_a@2x.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  padding-top: 560px;
  &.show-iframe {
    padding-top: 0;
  }
  .external-iframe {
    width: 100vw;
    height: 100vh;
    border: none;
  }
  .content {
    width: 100%;
    border-radius: 8px;
    margin: 0 auto;
    padding: 1px 30px 50px;
    .form {
      margin: 0 auto;
      width: 100%;
      .form-item {
        margin: 0 auto;
        width: 100%;
        height: 94px;
        line-height: 94px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        background-color: #ffffff;
        padding: 0 15px 0 30px;
        margin-top: 40px;
        font-size: 33px;
        font-family: PingFang SC;
        font-weight: 400;
        &.shake {
          animation: shake .3s linear
        }

        .nd-input {
          input {
            font-size: 33px;
            height: 50px;
            line-height: 50px;
          }
        }

        .form-tip.visible {
          color: transparent;
          opacity: 0;
        }

        .send-code {
          height: 61px;
          line-height: 61px;
          width: 183px;
          border: 1px solid #ff4633;
          color: #ff4633;
          background-color: white;
          border-radius: 31px;
          font-size: 27px;
          flex-shrink: 0;

          span {
            font-size: 27px;
          }

          &.disabled {
            color: @fc4;
            border: 1px solid @fc4;
          }
        }
      }

      .agree {
        display: inline-block;
        margin-top: 34px;
        height: 30px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        &.shake {
          animation: shake 1s linear
        }
        .highlight {
          color: #FF4633;
        }
        /deep/.van-checkbox__icon{
          font-size: 28px;
          .van-icon{
            border-color: #999999;
            border-width: 2px;
            &::before{
              color: #FFFFFF;
            }
          }
        }
        /deep/.van-checkbox__label{
          color: #999999;
        }
      }
      .btn-name {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        padding-top: 27px;
      }
      .btn {
        text-align: center;
        width: 630px;
        height: 100px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        line-height:100px;
        border-radius: 50px;
        font-size: 40px;
        color: #FFFFFF;
        font-weight: bold;
      }
    }
  }
  .protocol-popup {
    background-color: transparent;
    dl {
      background-color: #fff;
      border-radius: 30px 30px 0px 0px;
      padding-bottom: 80px;
      dt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 50px;
        height: 170px;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        > img {
          width: 33px;
          height: 33px;
        }
      }
      dd {
        height: 110px;
        padding: 0 40px;
        line-height: 110px;
        font-size:30px;
        border-top: 1px solid #EEEEEE;
      }
    }
  }
}
</style>